import React, { createContext, useState, useContext, useEffect } from "react";
import { completeResponse } from "../utils/utils";
import APIError from "../models/ApiError";

const SearchContext = createContext();

export const useSearchContext = () => {
  const context = useContext(SearchContext);

  if (context === undefined) {
    throw new Error("useSearchContext must be used within a SearchProvider");
  }
  return context;
};

export const SearchProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [objectProps, setObjectProps] = useState({});
  const [showModal, setShowModal] = useState(false);

  const handleApiResponse = (objectProps, showModal = false) => {
    const updatedObjectProps = completeResponse(objectProps);
    setObjectProps(updatedObjectProps);
    setShowModal(showModal);
  };

  const handleApiError = (error = {}, showModal = false) => {
    if (error instanceof APIError) {
      const updatedObjectProps = completeResponse(error);
      setObjectProps(updatedObjectProps);
    } else {
      const updatedObjectProps = completeResponse({
        message:
          "Ha ocurrido un error al realizar la acción. Vuelva a intentar más tarde",
      });
      setObjectProps(updatedObjectProps);
    }
    setShowModal(showModal);
  };

  const handleShowModal = (state) => {
    setShowModal(state);
  };

  useEffect(() => {
    if (showModal) {
      const timer = setTimeout(() => {
        setShowModal(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showModal]);

  return (
    <SearchContext.Provider
      value={{
        objectProps,
        showModal,
        searchTerm,
        results,
        setSearchTerm,
        setResults,
        handleApiResponse,
        handleApiError,
        handleShowModal,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};
